import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentFormModel } from '@base/models/form/payment-form.model';
import { PaymentPeriod } from '@base/backend';
import { IbanValidator } from '@base/validators/iban.validator';

export function createPaymentForm(): FormGroup<PaymentFormModel> {
  return new FormGroup<PaymentFormModel>({
    iban: new FormControl<string | null>(null, [Validators.required, IbanValidator.checksum()]),
    paymentPeriod: new FormControl<PaymentPeriod | null>(PaymentPeriod.Monthly, [Validators.required])
  });
}
